import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/plt.svg'


const _withScopeId = n => (_pushScopeId("data-v-18a640bb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = { class: "el-dropdown-link" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "el-dropdown-link" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("ERC-20"))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("ERC-721"))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("ERC-1155"))

import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElDropdown } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();

const blockChainRoutes = ["Blocks", "Txs", "Accounts", "Validators"];
const tokenRoutes = ["PLT", "ERC-20", "ERC-721", "ERC-1155"];

const isBlockchainRoute = computed(() =>
  blockChainRoutes.some((r) => r === route.name)
);
const isTokensRoute = computed(() => tokenRoutes.some((r) => r === route.name));

const navigateTo = (route: string) => {
  if (isBlockchainRoute || isTokensRoute) {
    router.push({
      name: route,
    });
  } else {
    router.push({
      name: "Home",
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('Home')))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("header.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo('Home')))
        }, _toDisplayString(_ctx.$t("header.home")), 1),
        _createElementVNode("div", {
          class: _normalizeClass(_unref(route).name == 'Home' ? 'line active' : 'line unactive')
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(ElDropdown), null, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo(blockChainRoutes[0])))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("header.blocks")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo(blockChainRoutes[1])))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("header.transactions")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateTo(blockChainRoutes[2])))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("header.accounts")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (navigateTo(blockChainRoutes[3])))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("header.validators")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("header.blockchain")), 1),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(isBlockchainRoute) ? 'line active' : 'line unactive')
            }, null, 2)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(ElDropdown), null, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, { slot: "dropdown" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (navigateTo(tokenRoutes[0])))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("plttoken.name")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (navigateTo(tokenRoutes[1])))
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (navigateTo(tokenRoutes[2])))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (navigateTo(tokenRoutes[3])))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("header.token")), 1),
            _createElementVNode("div", {
              class: _normalizeClass(_unref(isTokensRoute) ? 'line active' : 'line unactive')
            }, null, 2)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})